import { render, staticRenderFns } from "./IndexArticle.vue?vue&type=template&id=31d21a0d&scoped=true"
import script from "./IndexArticle.vue?vue&type=script&lang=js"
export * from "./IndexArticle.vue?vue&type=script&lang=js"
import style0 from "./IndexArticle.vue?vue&type=style&index=0&id=31d21a0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d21a0d",
  null
  
)

export default component.exports